import { render, staticRenderFns } from "./PasswordResetDialog.vue?vue&type=template&id=2b2937d3&"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=js&"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports